import {withNamespaces} from "react-i18next";
import React from "react";
import i18n from "../../../i18n";

const HERO_ASSETS = {
  'trainer-day': {
    desktop: '/images/booking/trainer-day-banner.jpg',
    mobile: '/images/booking/trainer-day-banner.jpg',
    alt: 'trainer-day-hero',
  },
  crunchone: {
    desktop: '/images/booking/coko-banner-desktop.jpg',
    mobile: '/images/booking/coko-logo-white.png',
    alt: 'crunch-hero',
  },
  promo: {
    desktop: '/images/booking/coko-promo-banner-desktop.jpg',
    mobile: '/images/booking/coko-promo-banner-desktop.jpg',
    alt: 'crunch-hero',
  },
};

const HERO_ASSETS_FR = {
  crunchone: {
    desktop: '/images/booking/plan-pret-partez-banner-fr-desktop.jpg',
    mobile: '/images/booking/plan-pret-partez-banner-fr-mobile.jpg',
    alt: 'crunch-hero',
  },
};

const BookingHeroComponent = (props) => {
  const currentLang = (props.lng || (props.i18n && props.i18n.language) || i18n.language || '').toLowerCase();
  const isFrench = currentLang.startsWith('fr');
  var assetKey = props.eventType || 'crunchone';
  if (assetKey === 'crunchone' && props.isPromotion) assetKey = 'promo';
  const useFrAssets = isFrench && Boolean(HERO_ASSETS_FR[assetKey]);
  const assets = useFrAssets
    ? HERO_ASSETS_FR[assetKey]
    : (HERO_ASSETS[assetKey] || HERO_ASSETS.crunchone);
  return (
    <div className="booking-hero">
      <img className='hero-logo hero-desktop' src={assets.desktop} alt={assets.alt} />
      <img className={`hero-logo hero-mobile${useFrAssets ? ' hero-mobile-fr' : ''}`} src={assets.mobile} alt={assets.alt} />
    </div>
  );
};

export default withNamespaces()(BookingHeroComponent);